"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SCHEMA = void 0;
const CoursePreloader_1 = __importDefault(require("./course/CoursePreloader"));
__exportStar(require("./course/CoursePreloader"), exports);
const FinishModal_1 = __importDefault(require("./course/FinishModal"));
__exportStar(require("./course/FinishModal"), exports);
const Header_1 = __importDefault(require("./course/Header"));
__exportStar(require("./course/Header"), exports);
const LandingSectionLayout_1 = __importDefault(require("./course/LandingSectionLayout"));
__exportStar(require("./course/LandingSectionLayout"), exports);
const NavButtons_1 = __importDefault(require("./course/NavButtons"));
__exportStar(require("./course/NavButtons"), exports);
const Scrollbar_1 = __importDefault(require("./course/Scrollbar"));
__exportStar(require("./course/Scrollbar"), exports);
const Sidebar_1 = __importDefault(require("./course/Sidebar"));
__exportStar(require("./course/Sidebar"), exports);
const TestAnswerFeedback_1 = __importDefault(require("./course/TestAnswerFeedback"));
__exportStar(require("./course/TestAnswerFeedback"), exports);
const TestFooter_1 = __importDefault(require("./course/TestFooter"));
__exportStar(require("./course/TestFooter"), exports);
const TestSectionLayout_1 = __importDefault(require("./course/TestSectionLayout"));
__exportStar(require("./course/TestSectionLayout"), exports);
const Accordion_1 = __importDefault(require("./elements/Accordion"));
__exportStar(require("./elements/Accordion"), exports);
const Audio_1 = __importDefault(require("./elements/Audio"));
__exportStar(require("./elements/Audio"), exports);
const Button_1 = __importDefault(require("./elements/Button"));
__exportStar(require("./elements/Button"), exports);
const Card_1 = __importDefault(require("./elements/Card"));
__exportStar(require("./elements/Card"), exports);
const Chart_1 = __importDefault(require("./elements/Chart"));
__exportStar(require("./elements/Chart"), exports);
const Checkbox_1 = __importDefault(require("./elements/Checkbox"));
__exportStar(require("./elements/Checkbox"), exports);
const Code_1 = __importDefault(require("./elements/Code"));
__exportStar(require("./elements/Code"), exports);
const CourseProgress_1 = __importDefault(require("./elements/CourseProgress"));
__exportStar(require("./elements/CourseProgress"), exports);
const CourseStructure_1 = __importDefault(require("./elements/CourseStructure"));
__exportStar(require("./elements/CourseStructure"), exports);
const Divider_1 = __importDefault(require("./elements/Divider"));
__exportStar(require("./elements/Divider"), exports);
const Downloader_1 = __importDefault(require("./elements/Downloader"));
__exportStar(require("./elements/Downloader"), exports);
const Embedded_1 = __importDefault(require("./elements/Embedded"));
__exportStar(require("./elements/Embedded"), exports);
const Grouping_1 = __importDefault(require("./elements/Grouping"));
__exportStar(require("./elements/Grouping"), exports);
const Image_1 = __importDefault(require("./elements/Image"));
__exportStar(require("./elements/Image"), exports);
const LabeledGraphic_1 = __importDefault(require("./elements/LabeledGraphic"));
__exportStar(require("./elements/LabeledGraphic"), exports);
const LayoutList_1 = __importDefault(require("./elements/LayoutList"));
__exportStar(require("./elements/LayoutList"), exports);
const Link_1 = __importDefault(require("./elements/Link"));
__exportStar(require("./elements/Link"), exports);
const List_1 = __importDefault(require("./elements/List"));
__exportStar(require("./elements/List"), exports);
const Rectangle_1 = __importDefault(require("./elements/Rectangle"));
__exportStar(require("./elements/Rectangle"), exports);
const Reflection_1 = __importDefault(require("./elements/Reflection"));
__exportStar(require("./elements/Reflection"), exports);
const RichText_1 = __importDefault(require("./elements/RichText"));
__exportStar(require("./elements/RichText"), exports);
const Simulator_1 = __importDefault(require("./elements/Simulator"));
__exportStar(require("./elements/Simulator"), exports);
const Slider_1 = __importDefault(require("./elements/Slider"));
__exportStar(require("./elements/Slider"), exports);
const Splitter_1 = __importDefault(require("./elements/Splitter"));
__exportStar(require("./elements/Splitter"), exports);
const Table_1 = __importDefault(require("./elements/Table"));
__exportStar(require("./elements/Table"), exports);
const Tabs_1 = __importDefault(require("./elements/Tabs"));
__exportStar(require("./elements/Tabs"), exports);
const TestFeedback_1 = __importDefault(require("./elements/TestFeedback"));
__exportStar(require("./elements/TestFeedback"), exports);
const TestGeneralFeedback_1 = __importDefault(require("./elements/TestGeneralFeedback"));
__exportStar(require("./elements/TestGeneralFeedback"), exports);
const TestGrouping_1 = __importDefault(require("./elements/TestGrouping"));
__exportStar(require("./elements/TestGrouping"), exports);
const TestHotspot_1 = __importDefault(require("./elements/TestHotspot"));
__exportStar(require("./elements/TestHotspot"), exports);
const TestInfoEnd_1 = __importDefault(require("./elements/TestInfoEnd"));
__exportStar(require("./elements/TestInfoEnd"), exports);
const TestInfoStart_1 = __importDefault(require("./elements/TestInfoStart"));
__exportStar(require("./elements/TestInfoStart"), exports);
const TestKeyboardInput_1 = __importDefault(require("./elements/TestKeyboardInput"));
__exportStar(require("./elements/TestKeyboardInput"), exports);
const TestMatching_1 = __importDefault(require("./elements/TestMatching"));
__exportStar(require("./elements/TestMatching"), exports);
const TestMultipleChoice_1 = __importDefault(require("./elements/TestMultipleChoice"));
__exportStar(require("./elements/TestMultipleChoice"), exports);
const TestRanking_1 = __importDefault(require("./elements/TestRanking"));
__exportStar(require("./elements/TestRanking"), exports);
const TestResult_1 = __importDefault(require("./elements/TestResult"));
__exportStar(require("./elements/TestResult"), exports);
const TestSingleChoice_1 = __importDefault(require("./elements/TestSingleChoice"));
__exportStar(require("./elements/TestSingleChoice"), exports);
const Video_1 = __importDefault(require("./elements/Video"));
__exportStar(require("./elements/Video"), exports);
exports.SCHEMA = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, CoursePreloader_1.default), FinishModal_1.default), Header_1.default), LandingSectionLayout_1.default), NavButtons_1.default), Scrollbar_1.default), Sidebar_1.default), TestAnswerFeedback_1.default), TestFooter_1.default), TestSectionLayout_1.default), Accordion_1.default), Audio_1.default), Button_1.default), Card_1.default), Chart_1.default), Checkbox_1.default), Code_1.default), CourseProgress_1.default), CourseStructure_1.default), Divider_1.default), Downloader_1.default), Embedded_1.default), Grouping_1.default), Image_1.default), LabeledGraphic_1.default), LayoutList_1.default), Link_1.default), List_1.default), Rectangle_1.default), Reflection_1.default), RichText_1.default), Simulator_1.default), Slider_1.default), Splitter_1.default), Table_1.default), Tabs_1.default), TestFeedback_1.default), TestGeneralFeedback_1.default), TestGrouping_1.default), TestHotspot_1.default), TestInfoEnd_1.default), TestInfoStart_1.default), TestKeyboardInput_1.default), TestMatching_1.default), TestMultipleChoice_1.default), TestRanking_1.default), TestResult_1.default), TestSingleChoice_1.default), Video_1.default);
